import { render, staticRenderFns } from "./WcLoadersInfiniteNoMore.vue?vue&type=template&id=f9b2ffb4&lang=pug&"
import script from "./WcLoadersInfiniteNoMore.vue?vue&type=script&lang=js&"
export * from "./WcLoadersInfiniteNoMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports